import 'react';
import { css } from 'styled-components';
import styledTheming from '../node_modules/styled-theming/index.js';
import '../App.css.js';
import './text-theme.js';
import './button-theme.js';
import img from '../faq_component/faq-icon-light.svg.js';
import img$1 from '../faq_component/faq-icon-dark.svg.js';

/*** GENERICS  ***/

var genericDivStyle = styledTheming("layout", {
  light: css(["transition:0.3s;"]),
  dark: css(["transition:0.3s;"])
});
/*** TEXT ***/

/*** ***/

/*** BACKGROUND ***/

var backgroundMain = styledTheming("layout", {
  light: "var(--white)",
  dark: "var(--black)"
});
var generalBackground = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: var(--dark-gray-9)",
    dark: "background-color: var(--white)"
  },
  red: {
    light: "background-color: var(--red)",
    dark: "background-color: var(--red)"
  },
  azure: {
    light: "background-color: var(--azure-telegram)",
    dark: "background-color: var(--azure-telegram)"
  },
  green: {
    light: "background-color: var(--green)",
    dark: "background-color: var(--green)"
  },
  white: {
    light: "background-color: var(--white)",
    dark: "background-color: var(--white)"
  },
  grayFour: {
    light: "background-color: var(--light-gray-4)",
    dark: "background-color: var(--dark-gray-4)"
  },
  grayEight: {
    light: "background-color: var(--light-gray-8)",
    dark: "background-color: var(--dark-gray-8)"
  },
  grayNine: {
    light: "background-color: var(--light-gray-9)",
    dark: "background-color: var(--dark-gray-9)"
  }
});
/*** BORDER***/

/*** COMPONENTS ****/

styledTheming("layout", {
  light: css(["url(", ")"], img),
  dark: css(["url(", ")"], img$1)
});
export { backgroundMain, generalBackground, genericDivStyle };